/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from '@/i18n/client';
import { DialogActions, DialogContent, DialogTitle, Radio } from '@mui/material';
import cn from 'clsx';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
// 组件
import UKDialog from '@/components/UKDialog';
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';
import AddressSearch from '@/components/address/AddressSearch';
import CommonButton from '../commonButton';
import EmptyPage from '../emptyPage';
import GoogleMaps from '../googleLocation';

// 接口
import { placeDetail } from '@/apis/address/address.api';
import { fetchPostHouseList } from '@/apis/afterSales/afterSales.api';
import { IPostHouseListReq, PostHouseListResVo } from '@/apis/afterSales/afterSales.interface';
import to from 'await-to-js';
// 图标
import VectorDown from '@/assets/icons/VectorDownBig.svg';
import UKPageNothing, { DefaultImageType } from '@/components/UKPageNothing';

interface locationModalProps {
  isOpen: boolean;
  selectValue: string; // 驿站的houseId
  selectPostCode: string; // 驿站的postCode
  // selectList: PostHouseListResVo[];
  selectChangeHandler: (value: any) => void;
  closeHandler: () => void;
  initParams: IPostHouseListReq;
  orderId: string;
}

const locationModal: React.FC<locationModalProps> = observer(
  ({
    selectValue,
    selectPostCode,
    selectChangeHandler,
    closeHandler,
    isOpen,
    initParams,
    orderId,
  }) => {
    const { t } = useTranslation();

    const [locationList, setLocationList] = useState<PostHouseListResVo[] | []>([]);
    const [curLocation, setCurLocation] = useState<PostHouseListResVo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [curHouseId, setCurHouseId] = useState(selectValue);
    // 当前展开的项ID（null 表示全部收起）
    const [expandedId, setExpandedId] = useState<string | null>(null);

    const searchBar = useRef<HTMLDivElement>(null);
    const searchList = useRef<HTMLDivElement>(null);

    // if (!selectList?.length) {
    //   return null;
    // }

    useEffect(() => {
      loadPostHouseList(initParams, true);
    }, [selectPostCode]);

    // 防抖函数
    const debounce = (func: () => void, delay: number) => {
      let timeoutId: NodeJS.Timeout;
      return () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(func, delay);
      };
    };

    // 获取驿站信息列表
    const loadPostHouseList = async (params: IPostHouseListReq, isFirst?: boolean) => {
      isFirst && setLoading(true);
      // const postCodeParams = params;
      const [err, postHouseListData] = await to(fetchPostHouseList(params));

      if (err) {
        // setError("Failed to fetch address list");
        setLocationList([]);
      } else {
        if (isFirst && selectPostCode) {
          const selectHouseItem = postHouseListData.find(
            (item) => item.postCode === selectPostCode,
          );
          setCurLocation(selectHouseItem as PostHouseListResVo);
        }
        setLocationList(postHouseListData as PostHouseListResVo[]);

        // setError(null);
      }
      setLoading(false);
    };

    // 选择地址
    const selectItemHandler = (item: PostHouseListResVo) => {
      setCurLocation(item);
      setCurHouseId(item.postHouseId);
    };

    const handleItemClick = (itemId: string) => {
      // 如果点击的是已展开的项，则收起；否则展开该新项
      setExpandedId(expandedId === itemId ? null : itemId);
    };

    // 根据搜索结果查询联想列表
    const handleSelectSearchResult = async (placeId: string) => {
      if (!placeId) return;
      setLoading(true);
      const [err, result] = await to(placeDetail({ placeId }));
      console.log(result?.data, 'wee---');
      if (result?.data) {
        const params = {
          postCode: result?.data?.postCode,
          firstAddressId: result?.data?.provinceId,
          firstAddressName: result?.data?.countyName,
          secondAddressId: result?.data?.cityId,
          secondAddressName: result?.data?.urbanName,
          thirdAddressId: result?.data?.districtId,
          fourthAddressId: result?.data?.townId,
          addressDetail: result?.data?.addressDetail,
          houseNumber: result?.data?.houseNumber,
          orderId,
        };
        loadPostHouseList(params);
      } else {
        console.log('err', err);
        setLoading(false);
      }
      // result?.data && setCurrentAddressInfo(result.data);
    };

    return (
      <UKDialog
        open={isOpen}
        onClose={() => {
          closeHandler();
        }}
        showCloseBtn={true}
        sx={{
          '& .MuiDialog-paper': {
            width: '880px', // 设置自定义宽度
            height: '82vh',
          },
        }}
      >
        <DialogTitle>{t('order.orderDetail.returnRequestModal.dropOffText')}</DialogTitle>
        <DialogContent
          sx={{
            paddingBottom: '16px',
          }}
        >
          <div className={styles.selectWrap}>
            <div className={styles.searchBarWrap} ref={searchBar}>
              {/* <FormControl fullWidth={true}>
              <Input
                autoFocus
                sx={{
                  borderRadius: "4px",
                  height: "36px",
                  fontSize: "14px",
                  border: "1px solid #1A1A1A",
                  padding: "0 12px",
                }}
                value={postCode || ""}
                type="text"
                onChange={handleCodeChange}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => codeKeyDown(e)}
                disableUnderline
                endAdornment={
                  <InputAdornment position="end">
                    {postCode ? (
                      <>
                        <div
                          onClick={() => {
                            setPostCode("");
                          }}
                          className={styles.inputEndAdornmentStyle}
                        >
                          <Closed />
                        </div>
                      </>
                    ) : null}
                    <SearchIcon />
                  </InputAdornment>
                }
                placeholder={t("order.orderDetail.locationModal.inputPlaceholder")}
              />
            </FormControl> */}
              <AddressSearch onSearch={handleSelectSearchResult} />
            </div>
            <div className={styles.searchListWrap} ref={searchList}>
              {loading ? (
                <div className={styles.loadingWrap}>
                  <UKLoadingIcon type={CIRCLE_COLOR_MAP.BLACK} />
                  <span className={styles.loadingText}>{t('common.pageStatus.loading')}</span>
                </div>
              ) : locationList?.length ? (
                <>
                  <GoogleMaps
                    updateLocation={(location) => {
                      setCurLocation(location);
                      setCurHouseId(location.postHouseId);
                    }}
                    locationList={locationList}
                    curLocationInfo={curLocation}
                  />
                  <div className={styles.locationListWrap}>
                    {locationList?.map((item) => {
                      return (
                        <div
                          key={item.postHouseId}
                          className={styles.searchResultItem}
                          onClick={() => {
                            selectItemHandler(item);
                            handleItemClick(item.postCode);
                          }}
                        >
                          <div className={styles.locationItemWrap}>
                            <Radio
                              disableRipple
                              checked={curHouseId === item.postHouseId}
                              size='small'
                              sx={{
                                padding: 0,
                              }}
                            />
                            <div className={styles.locationMain}>
                              <div className={styles.locationName}>
                                {item?.postHouseName}
                                {/* {item?.distance ? <span className={styles.locationDis}>{item?.distance}</span> : null} */}
                              </div>
                              <div className={styles.locationDesc}>{item?.fullAddressDetail}</div>
                              {expandedId === item.postCode && item?.businessHours?.length ? (
                                <>
                                  <div className={styles.businessHoursTitle}>
                                    {t('afterSales.afterSalesAccordion.openingTime')}
                                  </div>
                                  {item.businessHours.map((ele, index) => {
                                    return (
                                      <div
                                        key={`businessHours-${index}`}
                                        className={styles.businessHoursItem}
                                      >
                                        <div>{ele.title}</div>
                                        <div>{ele.subTitle}</div>
                                      </div>
                                    );
                                  })}
                                </>
                              ) : null}
                            </div>
                          </div>
                          <VectorDown
                            className={cn(styles.moreIco, {
                              [styles.retractIco]: expandedId === item.postCode,
                            })}
                          />
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className={styles.emptyWrap}>
                  <UKPageNothing
                    defaultImageType={DefaultImageType.DEFAULT_NOTING}
                    text={t('order.orderDetail.locationModal.emptyText')}
                    textStyle={{ width: '100%' }}
                  />
                </div>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions
          sx={{
            paddingBottom: '16px',
          }}
        >
          <CommonButton variant='outlined' onClick={closeHandler}>
            {t('order.orderList.common.cancelBtnText')}
          </CommonButton>
          <CommonButton
            variant='contained'
            sx={{ boxShadow: 'none' }}
            onClick={() => {
              selectChangeHandler && selectChangeHandler(curLocation);
            }}
            disabled={!curLocation || loading}
          >
            {t('order.orderList.common.saveBtnText')}
          </CommonButton>
        </DialogActions>
      </UKDialog>
    );
  },
);

export default locationModal;
